import React from 'react';
import './index.css';
import Routes from './Routes';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';

function App() {

  const queryClient = new QueryClient()

  return (
    <main style={{ fontFamily: 'Satoshi' }}>
        <Provider store={store}>
         <QueryClientProvider client={queryClient}>
          <Routes/>
          <Toaster position='top-center' richColors/>
          <ToastContainer />
          </QueryClientProvider>
        </Provider>
    </main>
  );
}

export default App;
